var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-apex-charts',{attrs:{"type":"heatmap","height":"350","options":_vm.apexChatData.heatMapChart.chartOptions,"series":_vm.apexChatData.heatMapChart.series}})}
var staticRenderFns = []

export { render, staticRenderFns }